<script>
	import { onMount } from 'svelte';

	let inputString = '';

	onMount(async () => {
		let url = new URL(window.location.href.replace('#',''));
		if (queryTextExists(url)) {
			inputString = decodeURI(url.searchParams.get('queryText'));
		}
	})

	window.onhashchange = function() { 
		let url = new URL(window.location.href.replace('#',''));
		if (queryTextExists(url)) {
			inputString = decodeURI(url.searchParams.get('queryText'));
		}
	}

	function queryTextExists(url) {
		return url.searchParams && url.searchParams.get('queryText') && url.searchParams.get('queryText').length > 0;
	}

	function handleClick() {
		if (inputString.length > 0) {
			let search1 = new URLSearchParams();
			search1.append('queryText', encodeURI(inputString));
			window.location.href = `../Xplorehelp/search?${search1.toString()}`;
		}
	}
	function handleEnter(e) {
		if (e.keyCode === 13) {
			handleClick();
		}
	}

</script>

<style>
	* {
		font-family: sans-serif;
	}
	.search-bar-container {
		display: flex;
		width: 100%;
		background-color: #14303e;
		justify-content: center;;
	}
	.search-bar {
		display: flex;
		width: 90%;
		padding: .5rem 0 1rem;
	}
	.search-bar-input {
		width: 100%;
		padding: .5rem;
		border: none;
		font-size: 1rem;
	}
	.search-button {
		border: none;
		border: .5px solid white;
		cursor: pointer;
		padding: .25rem .5rem;
		background-color: #e4a42c;
		padding: .25rem .75rem;
		color: black;
	}

	.resource-header {
		display: flex;
		font-size: .85rem;
		align-items: center;
		background-color: #C3C3C3;
		padding: 0 .5rem;
	}
	.search-icon { 
		padding: 0 .15rem;
	}
	@media only screen and (max-device-width: 768px) {
		.resource-header {
			background-color: #ddd;
		}
	}
</style>

<div class="search-bar-container">
	<div class="search-bar max-width">
		<div class="resource-header">Resources</div>
		<input class="search-bar-input" bind:value={inputString} on:keydown={handleEnter} placeholder="Search Resouces and Help">
		<button class="search-button" on:click={handleClick}>
			<i class="search-icon fas fa-search"></i>
		</button>
	</div>
</div>
